import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from "reactstrap";
import Chart from "react-apexcharts";

const ActionsGraph = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleone = () => setDropdownOpen((prevState) => !prevState);

  const [dropdownOpentwo, setDropdownOpentwo] = useState(false);
  const toggletwo = () => setDropdownOpentwo((prevState) => !prevState);

  const chartOptions = {
    series: [{
      name: 'Update Form',
      data: [44, 55, 41, 67, 22, 43]
    }, {
      name: 'Upload Document',
      data: [13, 23, 20, 8, 13, 27]
    }, {
      name: 'Verify Form',
      data: [11, 17, 15, 15, 21, 14]
    }],
    options: {
      theme: {
        palette: 'palette2',
        monochrome: {
            shadeIntensity: 0.6
      }},
      chart: {
        type: 'bar',
        height: 350,
        stacked: true
      }
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 pt-4">
        <h4>Actions</h4>
        <div className="d-flex justify-content-between align-items-center gap-4">
          <Label>Filter By : </Label>
          <div className="drop_block">
            <Dropdown isOpen={dropdownOpen} toggle={toggleone}>
              <DropdownToggle caret size="xl" className="filter_block">
                All Organization <i className="fa fa-caret-down"></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">1</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">2</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">3</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <p>AND</p>
          <div className="drop_block">
            <Dropdown isOpen={dropdownOpen} toggle={toggleone}>
              <DropdownToggle caret size="xl" className="filter_block">
                All Organization <i className="fa fa-caret-down"></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">1</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">2</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">3</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <p>OR</p>
          <div className="drop_block">
            <Dropdown isOpen={dropdownOpentwo} toggle={toggletwo}>
              <DropdownToggle caret size="xl" className="filter_block">
                All State <i className="fa fa-caret-down"></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">1</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">2</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">3</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="">
        <div className="graph_block_two">
        <Chart
              options={chartOptions.options}
              series={chartOptions.series}
              type="bar"
              width="100%"
              height="400"
            />
        </div>
      </div>
    </>
  );
};

export default ActionsGraph;
